import ZoomIn from '../../src/legacy/ZoomIn';
export default ZoomIn;
